export enum Serverities {
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  INFO = 'INFO',
  TERTIARY = 'TERTIARY',
}
